import React from 'react'
import Heading from '../shared/Heading'
import SellerCard from './SellerCard'
import ItemCard from './ItemCard'
import { everyDayMeals } from '../constants'

const TopDeals = () => {
    let data = {
        id: 1,
        price: 370,
        title: 'Krunch Burger',
        image: 'https://www.kfcpakistan.com/images/43a95f10-ffaa-11ed-b673-4121381f04c6-CrispyDuoBox-2023-05-31115706.png',
        description: 'Turn up the fun with 5 pcs Hot & Crispy Chicken + 1 Large fries + 2 Regular drinks',
    }
  return (
    <div className='container mx-auto my-3'>
      <Heading data="Top Deals" />
      <div className="flex gap-5 mt-6 justify-start w-full flex-wrap">
      {everyDayMeals.map((item) => (
                    <div key={item.id} className='lg:w-[22%] sm:w-full md:w-[45%]'>
                        <ItemCard data={item}/>
                    </div>
                ))}
      </div>
    </div>
  )
}

export default TopDeals
